import { render, staticRenderFns } from "./split-file.vue?vue&type=template&id=662aad78&scoped=true"
import script from "./split-file.vue?vue&type=script&lang=js"
export * from "./split-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662aad78",
  null
  
)

export default component.exports